import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'

// This hook is used to determine if the overview route should be treated as the index route for pull requests.
// We need to check the embedded feature flag 'prs_overview_as_index_route' to see if it is enabled.
// The embedded feature flag was necessary to change the index route definition at runtime.
export function useOverviewIsIndexRoute() {
  // eslint-disable-next-line @github-ui/github-monorepo/no-use-feature-flags
  return useFeatureFlag('prs_overview_as_index_route')
}
